import useDelay from '@nicolaudie-group/ng-ui-kit/composables/useDelay'

function useDebounceFn(handler, time, maxWait) {
  let lastCalled = Date.now()

  const { delay, reset } = useDelay()

  function call(...args) {
    lastCalled = Date.now()
    handler(...args)
  }

  function debouncedFn(...args) {
    reset() // Reset the current delay
    if (maxWait && lastCalled + maxWait < Date.now()) {
      // If maxWait is set, and maxWait is elapsed
      return call(...args) // Call handler & set lastCalled time
    }
    // If no maxWait is set or maxWait is not elapsed yet
    delay(() => call(...args), time) // After the provided time, call handler & set lastCalled time
    return undefined
  }

  return debouncedFn
}

export default useDebounceFn
